<ps-header *ngIf="userLoggedIn$ | async"></ps-header>
<ps-ui-loader *ngIf="isDisplayWheel"></ps-ui-loader>
<div [class.body-container]="userLoggedIn$ | async">
  <router-outlet></router-outlet>
</div>
